import { JItem, sortString } from '@centerpiece/components';
import {
  createFilterOptions,
  Tooltip,
  IconButton,
  InputAdornment,
} from '@mui/material';
import { renderStakeholderContactGroups } from 'jformik/useProjectForm';
import { Outcome, Role, Stage, SubscriptionContact } from 'store/api/models';
import { getIn } from 'yup/lib/util/reach';
import { stakeHolderOptions } from './contacts.utils';
import {
  roleStakeholder,
  useStakeholderForm,
} from 'jformik/useStakeholderForm';
import { organization, useGetProjectStateReasonsQuery } from 'store/api';
import * as Yup from 'yup';
import { useMemo } from 'react';

export const useTrackWorkFlow = ({
  win_loss,
  setOpenContact,
}: {
  win_loss: boolean;
  setOpenContact: Function;
}): (({
  stage,
  outcome,
  nextStage,
  projectTitle,
}: {
  stage?: Stage;
  outcome: Outcome | null;
  nextStage: Stage;
  projectTitle: string;
}) => {
  initialValues: any;
  validationSchema: any;
  title: string;
  content: string;
  form: JItem[];
} | null) => {
  const stakeholderForm = useStakeholderForm(setOpenContact);
  const competitorForm = useStakeholderForm(setOpenContact, 'competitors');

  const { data: reasons } = useGetProjectStateReasonsQuery({});
  return ({
    stage,
    outcome,
    nextStage,
    projectTitle,
    initialValues,
  }: {
    stage?: Stage;
    outcome: Outcome | null;
    nextStage: Stage;
    projectTitle: string;
    initialValues?: any;
  }): {
    initialValues: any;
    validationSchema: any;
    title: string;
    content: string;
    form: JItem[];
  } | null => {
    if (win_loss) {
      if (outcome?.state_r?.name === 'Lost') {
        return {
          initialValues: initialValues || {
            type: 'lost',
            outcome,
            nextStage,
            stakeholders: [
              {
                stakeholdertype: {
                  id: 7,
                  name: 'General Contractor',
                  type: 'External',
                },
                role: {
                  id: 7,
                  name: 'General Contractor',
                  type: 'External',
                },
                contact: null,
                dynamic: null,
                new: true,
              },
              {
                stakeholdertype: {
                  id: 8,
                  name: 'Design Consultant',
                  type: 'External',
                },
                role: {
                  id: 8,
                  name: 'Design Consultant',
                  type: 'External',
                },
                contact: null,
                dynamic: null,
                new: true,
              },
            ],
            competitors: [
              {
                stakeholdertype: {
                  id: 9,
                  name: 'Dealer',
                  type: 'External',
                },
                role: {
                  id: 9,
                  name: 'Dealer',
                  type: 'External',
                },
                contact: null,
                dynamic: null,
                new: true,
              },
            ],
          },
          validationSchema: Yup.object().shape({
            // stakeholders: Yup.array().of(
            //   Yup.object().shape({
            //     contact: Yup.object()
            //       .nullable()
            //       .required('Please select a contact or organization'),
            //   })
            // ),
            // competitors: Yup.array().of(
            //   Yup.object().shape({
            //     contact: Yup.object()
            //       .nullable()
            //       .required('Please select a contact or organization'),
            //   })
            // ),
            reason: Yup.object().nullable().required(`Please add a reason.`),
          }),
          title: `Mark ${projectTitle} as Lost`,
          content: 'Please specify the winning stakeholders.',
          form: [
            {
              name: 'stakeholder-fields',
              itemType: 'typography',
              jItemProps: {
                variant: 'overline',
                sx: {
                  mb: '0 !important',
                  pb: '0 !important',
                  minWidth: '50vw',
                },
                tooltip:
                  'This refers to the stakeholders who were responsible for awarding you or a competitor this project',
                tooltipPlacement: 'right',
              },
              label: `Awarding stakeholders`,
            },
            stakeholderForm,
            {
              name: 'competitor-fields',
              itemType: 'typography',
              jItemProps: {
                variant: 'overline',
                sx: {
                  mb: '0 !important',
                  pb: '0 !important',
                  minWidth: '50vw',
                },
              },
              label: `Winning Competitor`,
            },
            competitorForm,
            {
              name: 'additional-fields',
              itemType: 'typography',
              jItemProps: {
                variant: 'overline',
                sx: {
                  mb: '0 !important',
                  pb: '0 !important',
                  minWidth: '50vw',
                },
              },
              label: `Additional Information`,
            },
            {
              name: 'reason',
              itemType: 'autocomplete',
              options: reasons,
              label: 'Please select the reason for losing *',
            },
            {
              name: 'details',
              itemType: 'textfield',
              label: 'Please provide all relevant details on the loss',
              jItemProps: {
                multiline: true,
                minRows: 3,
              },
            },
          ],
        };
      } else if (outcome && !outcome?.state && nextStage?.stage_r.awarded) {
        return {
          initialValues: initialValues || {
            type: 'won',
            outcome,
            nextStage,
            stakeholders: [
              {
                stakeholdertype: {
                  id: 7,
                  name: 'General Contractor',
                  type: 'External',
                },
                role: {
                  id: 7,
                  name: 'General Contractor',
                  type: 'External',
                },
                contact: null,
                dynamic: null,
                new: true,
              },
              {
                stakeholdertype: {
                  id: 8,
                  name: 'Design Consultant',
                  type: 'External',
                },
                role: {
                  id: 8,
                  name: 'Design Consultant',
                  type: 'External',
                },
                contact: null,
                dynamic: null,
                new: true,
              },
            ],
          },
          validationSchema: Yup.object().shape({
            // stakeholders: Yup.array().of(
            //   Yup.object().shape({
            //     contact: Yup.object()
            //       .nullable()
            //       .required('Please select a contact or organization'),
            //   })
            // ),
            // reason: Yup.object().nullable().required(`Please add a reason.`),
          }),
          title: `Mark ${projectTitle} as Awarded`,
          content: 'Please specify the winning stakeholders.',
          form: [
            {
              name: 'stakeholder-fields',
              itemType: 'typography',
              jItemProps: {
                variant: 'overline',
                sx: {
                  mb: '0 !important',
                  pb: '0 !important',
                  minWidth: '50vw',
                },
                tooltip:
                  'This refers to the stakeholders who were responsible for awarding you or a competitor this project',
                tooltipPlacement: 'right',
              },
              label: `Awarding stakeholders`,
            },
            stakeholderForm,
            {
              name: 'additional-fields',
              itemType: 'typography',
              jItemProps: {
                variant: 'overline',
                sx: {
                  mb: '0 !important',
                  pb: '0 !important',
                  minWidth: '50vw',
                },
              },
              label: `Additional Information`,
            },
            {
              name: 'details',
              itemType: 'textfield',
              label: 'Please provide all relevant details on the win',
              jItemProps: {
                multiline: true,
                minRows: 3,
              },
            },
          ],
        };
      }
    }
    return null;
  };
};

export const useGetWorkFlowForm = ({
  setOpenContact,
}: {
  setOpenContact: Function;
}) => {
  const stakeholderForm = useStakeholderForm(setOpenContact);
  const competitorForm = useStakeholderForm(setOpenContact, 'competitors');
  const { data: reasons } = useGetProjectStateReasonsQuery({});
  return (
    stage: Stage
  ): {
    initialValues: any;
    validationSchema: any;
    stage: Stage;
    title: string;
    content?: string;
    form: JItem[];
  } | null => {
    const workflow = stage?.form?.workflow;
    if (workflow?.type === 'lost') {
      return {
        initialValues: {
          ...workflow,
          stakeholders: workflow.stakeholders?.map((s: any) => ({
            ...s,
            contact: !!s.contact
              ? s.contact
              : { ...s.organization, type: 'organization' },
            contact_r: s.contact,
            organization_r: s.organization,
          })),
          competitors: workflow.competitors?.map((s: any) => ({
            ...s,
            contact: !!s.contact
              ? s.contact
              : { ...s.organization, type: 'organization' },
            contact_r: s.contact,
            organization_r: s.organization,
          })),
        },
        validationSchema: Yup.object().shape({
          // stakeholders: Yup.array().of(
          //   Yup.object().shape({
          //     contact: Yup.object()
          //       .nullable()
          //       .required('Please select a contact or organization'),
          //   })
          // ),
          reason: Yup.object().nullable().required(`Please add a reason.`),
        }),
        stage: stage,
        title: `Awarding stakeholders.`,
        form: [
          {
            name: 'stakeholder-fields',
            itemType: 'typography',
            jItemProps: {
              variant: 'overline',
              sx: {
                mb: '0 !important',
                pb: '0 !important',
                minWidth: '50vw',
              },
              tooltip:
                'This refers to the stakeholders who were responsible for awarding you or a competitor this project',
              tooltipPlacement: 'right',
            },
            label: `Awarding stakeholders`,
          },
          stakeholderForm,
          {
            name: 'competitor-fields',
            itemType: 'typography',
            jItemProps: {
              variant: 'overline',
              sx: {
                mb: '0 !important',
                pb: '0 !important',
                minWidth: '50vw',
              },
            },
            label: `Winning Competitor`,
          },
          competitorForm,
          {
            name: 'additional-fields',
            itemType: 'typography',
            jItemProps: {
              variant: 'overline',
              sx: {
                mb: '0 !important',
                pb: '0 !important',
                minWidth: '50vw',
              },
            },
            label: `Additional Information`,
          },
          {
            name: 'reason',
            itemType: 'autocomplete',
            options: reasons,
            label: 'Please select the reason for losing *',
          },
          {
            name: 'details',
            itemType: 'textfield',
            label: 'Please provide all relevant details on the loss',
            jItemProps: {
              multiline: true,
              minRows: 3,
            },
          },
        ],
      };
    } else if (workflow?.type === 'won') {
      return {
        initialValues: {
          ...workflow,
          stakeholders: workflow.stakeholders?.map((s: any) => ({
            ...s,
            contact: !!s.contact
              ? s.contact
              : { ...s.organization, type: 'organization' },
            contact_r: s.contact,
            organization_r: s.organization,
          })),
          competitors: workflow.competitors?.map((s: any) => ({
            ...s,
            contact: !!s.contact
              ? s.contact
              : { ...s.organization, type: 'organization' },
            contact_r: s.contact,
            organization_r: s.organization,
          })),
        },
        validationSchema: Yup.object().shape({
          // stakeholders: Yup.array().of(
          //   Yup.object().shape({
          //     contact: Yup.object()
          //       .nullable()
          //       .required('Please select a contact or organization'),
          //   })
          // ),
          // reason: Yup.object().nullable().required(`Please add a reason.`),
        }),
        stage: stage,
        title: `Awarding stakeholders.`,
        form: [
          {
            name: 'stakeholder-fields',
            itemType: 'typography',
            jItemProps: {
              variant: 'overline',
              sx: {
                mb: '0 !important',
                pb: '0 !important',
                minWidth: '50vw',
              },
              tooltip:
                'This refers to the stakeholders who were responsible for awarding you or a competitor this project',
              tooltipPlacement: 'right',
            },
            label: `Awarding stakeholders`,
          },
          stakeholderForm,
          {
            name: 'additional-fields',
            itemType: 'typography',
            jItemProps: {
              variant: 'overline',
              sx: {
                mb: '0 !important',
                pb: '0 !important',
                minWidth: '50vw',
              },
            },
            label: `Additional Information`,
          },
          {
            name: 'details',
            itemType: 'textfield',
            label: 'Please provide all relevant details on the win',
            jItemProps: {
              multiline: true,
              minRows: 3,
            },
          },
        ],
      };
    }
    return null;
  };
};
